module.exports = __webpack_public_path__ + "static/media/qtt.db24e6a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/static/voice/qtt.wav
// module id = 01AF
// module chunks = 1